/* eslint-disable react/prop-types */
import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";
import { Row, Button, UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu, Collapse } from "reactstrap";
import _ from "lodash";
import { connect } from "react-redux";
import IntlMessages from "../../../helpers/IntlMessages";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import {
  getRequestListDelta,
  selectedRequestItemsChange,
  getRequestFastCheckinListWithFilter,
  getRequestFastCheckinListWithOrder,
  getRequestFastCheckinListSearch
} from "../../../redux/request/actions";
import RequestListItem from "../../../components/requests/RequestListItem";
import AddNewRequestModal from "../../../containers/requests/AddNewRequestModal";
import FastCheckinApplicationMenu from "../../../containers/fastCheckin/FastCheckinApplicationMenu";
import ScrollButton from "../../../components/gotoTopScrollButton/ScrollButton";

class FastCheckinApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
      modalOpen: false,
      lastChecked: null,
      thirtySecondsPassedAfterDidMount: false,
      displayOptionsIsOpen: false
    };
  }

  componentDidMount() {
    // this.props.getRequestListDelta({ allRequestItems: this.props.requestApp.allRequestItems });
    // searchKeywordFastCheckin

    if (this.props.requestApp.filterFastCheckin) {
      this.props.getRequestFastCheckinListWithFilter(this.props.requestApp.filterFastCheckin.column, this.props.requestApp.filterFastCheckin.value);
    }
    if (this.props.requestApp.orderColumnFastCheckin) {
      this.props.getRequestFastCheckinListWithOrder(
        `${this.props.requestApp.orderColumnFastCheckin.column}`,
        `${this.props.requestApp.orderColumnFastCheckin.direction}`
      );
    }

    this.connectionTimer = setTimeout(() => {
      this.setState({ thirtySecondsPassedAfterDidMount: true });
    }, 30000);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !this.isArrayEqual(prevProps.requestApp.fastCheckinItems, this.props.requestApp.fastCheckinItems) ||
      prevProps.locale !== this.props.locale ||
      !this.isArrayEqual(prevProps.requestApp.requestItems, this.props.requestApp.requestItems)
    ) {
      if (this.props.requestApp.filterFastCheckin) {
        this.props.getRequestFastCheckinListWithFilter(this.props.requestApp.filterFastCheckin.column, this.props.requestApp.filterFastCheckin.value);
      }
      if (this.props.requestApp && this.props.requestApp.orderColumnFastCheckin) {
        this.props.getRequestFastCheckinListWithOrder(
          this.props.requestApp.orderColumnFastCheckin.column,
          this.props.requestApp.orderColumnFastCheckin.direction
        );
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.connectionTimer);
  }

  getIndex(value, arr, prop) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i][prop] === value) {
        return i;
      }
    }
    return -1;
  }

  isArrayEqual = (x, y) => {
    const isEqual = (obj1, obj2) => {
      return obj1.id === obj2.id && obj1.created_at === obj2.created_at && obj1.updated_at === obj2.updated_at;
    };

    return _(x)
      .xorWith(y, isEqual)
      .isEmpty();
  };

  toggleDisplayOptions = () => {
    this.setState({ displayOptionsIsOpen: !this.state.displayOptionsIsOpen });
  };

  toggleModal = () => {
    this.setState({
      modalOpen: !this.state.modalOpen
    });
  };

  toggleSplit = () => {
    this.setState(prevState => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen
    }));
  };

  changeOrderBy = (column, direction = "asc") => {
    this.props.getRequestFastCheckinListWithOrder(column, direction);
  };

  handleKeyPress = e => {
    // if (e.key === 'Enter') {
    this.props.getRequestFastCheckinListSearch(e.target.value);
    if (this.props.requestApp && this.props.requestApp.orderColumnFastCheckin) {
      this.changeOrderBy(`${this.props.requestApp.orderColumnFastCheckin.column}`, `${this.props.requestApp.orderColumnFastCheckin.direction}`);
    }
    // }
  };

  handleCheckChange = (event, id) => {
    event.preventDefault();
    if (this.state.lastChecked == null) {
      this.setState({
        lastChecked: id
      });
    }

    let selectedItems = Object.assign([], this.props.requestApp.selectedItems);
    if (selectedItems.includes(id)) {
      selectedItems = selectedItems.filter(x => x !== id);
    } else {
      selectedItems.push(id);
    }
    this.props.selectedRequestItemsChange(selectedItems);

    if (event.shiftKey) {
      let items = this.props.requestApp.requestItems;
      const start = this.getIndex(id, items, "id");
      const end = this.getIndex(this.state.lastChecked, items, "id");
      items = items.slice(Math.min(start, end), Math.max(start, end) + 1);
      selectedItems.push(
        ...items.map(item => {
          return item.id;
        })
      );
      selectedItems = Array.from(new Set(selectedItems));
      this.props.selectedRequestItemsChange(selectedItems);
    }
  };

  handleChangeSelectAll = () => {
    if (this.props.requestApp.loading) {
      if (this.props.requestApp.selectedItems.length >= this.props.requestApp.requestItems.length) {
        this.props.selectedRequestItemsChange([]);
      } else {
        this.props.selectedRequestItemsChange(this.props.requestApp.requestItems.map(x => x.id));
      }
    }
  };

  fetchMore = () => {
    const { requestApp, getRequestListDelta, getRequestListWithFilter } = this.props;
    getRequestListDelta(true);
    if (requestApp.filter) {
      getRequestListWithFilter(requestApp.filter.column, requestApp.filter.value);
    }
  };

  loadMoreButton = () => {
    const {
      requestApp: { allLoaded, requestItems }
    } = this.props;
    const oldestItemDate = new Date(
      requestItems?.sort((aItem, bItem) => aItem.updated_at - bItem.updated_at)?.[0]?.updated_at * 1000
    )?.toLocaleDateString();
    if (allLoaded) {
      return (
        <Button color="light">
          <IntlMessages id="seen_all" /> <IntlMessages id="click_to_load_until" />
          {oldestItemDate}
        </Button>
      );
    }
    return (
      <Button color="primary" onClick={this.fetchMore}>
        <IntlMessages id="click_to_load" /> <IntlMessages id="click_to_load_until" /> {oldestItemDate}
      </Button>
    );
  };

  render() {
    const {
      match,
      requestApp: { fastCheckinItems, searchKeywordFastCheckin, loading, orderColumnFastCheckin, orderColumns },
      intl: { messages }
    } = this.props;

    const { modalOpen, thirtySecondsPassedAfterDidMount, displayOptionsIsOpen } = this.state;
    let fastCheckinItemsList;
    if (fastCheckinItems && fastCheckinItems.length) {
      fastCheckinItemsList = fastCheckinItems.map((item, index) => (
        <RequestListItem
          key={`request_item_${index}`}
          item={item}
          handleCheckChange={this.handleCheckChange}
          isSelected
          // isSelected={loading ? selectedItems.includes(item.id) : false}

          match={match}
        />
      ));
    } else if (thirtySecondsPassedAfterDidMount || loading) {
      fastCheckinItemsList = (
        <div className="text-center">
          {/* <i className="iconsminds-information text-muted" style={{ fontSize: '25px' }} /> */}
          <div className="list-item-heading mb-2 text-muted px-4" style={{ fontSize: "25px" }}>
            <i className="iconsminds-inbox-empty text-muted" />
            <IntlMessages id="request.empty_request_list" />
          </div>
        </div>
      );
    } else fastCheckinItemsList = <div className="loading" />;

    return (
      <div>
        <Fragment>
          <Row className="app-row survey-app">
            <Colxx xxs="12">
              <div style={{ backgroundColor: "#f8f8f8", position: "sticky", top: "3%", zIndex: "1" }}>
                <div className="mb-2">
                  <h1>
                    <IntlMessages id="menu.fastCheckin" />
                  </h1>
                  {loading && <div className="text-zero top-right-button-container" />}
                </div>

                <div className="mb-2">
                  <Button color="empty" className="d-inline-block d-md-none" onClick={this.toggleDisplayOptions}>
                    <IntlMessages id="request.display-options" /> <i className="simple-icon-arrow-down align-middle" />
                  </Button>
                  <Collapse id="displayOptions" className="d-md-block" isOpen={displayOptionsIsOpen}>
                    <div className="d-block mb-2 d-md-inline-block">
                      <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                        <DropdownToggle caret color="outline-dark" size="xs">
                          <IntlMessages id="request.orderby" />
                          {orderColumnFastCheckin ? <IntlMessages id={`request.${orderColumnFastCheckin.label}`} /> : ""}
                        </DropdownToggle>
                        <DropdownMenu>
                          {orderColumns &&
                            Object.values(orderColumns).length &&
                            orderColumns.map((o, index) => {
                              return (
                                <DropdownItem key={o.column} onClick={() => this.changeOrderBy(o.column, o.direction)}>
                                  <IntlMessages id={`request.${o.label}`} />
                                </DropdownItem>
                              );
                            })}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                      <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                        <input
                          type="text"
                          name="keyword"
                          id="search"
                          placeholder={messages["menu.search"]}
                          defaultValue={searchKeywordFastCheckin}
                          onChange={this.handleKeyPress}
                        />
                      </div>
                    </div>
                  </Collapse>
                </div>
                <Separator className="mb-5" />
              </div>
              <Row>{fastCheckinItemsList}</Row>
              <ScrollButton className={"app-row"} />
              <div className="d-flex flex-column">{this.loadMoreButton()}</div>
            </Colxx>
          </Row>
          <FastCheckinApplicationMenu />
          <AddNewRequestModal toggleModal={this.toggleModal} modalOpen={modalOpen} />
        </Fragment>
      </div>
    );
  }
}
const mapStateToProps = ({ requestApp, settings }) => {
  const { locale } = settings;
  return { requestApp, locale };
};
export default injectIntl(
  connect(
    mapStateToProps,
    {
      getRequestListDelta,
      getRequestFastCheckinListWithFilter,
      getRequestFastCheckinListWithOrder,
      getRequestFastCheckinListSearch,
      selectedRequestItemsChange
    }
  )(FastCheckinApp)
);
